import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "./card";
import { Button } from "./button";
import { profileData } from "@/data/mock";

const ProfileInfo = () => {
  return (
    <>
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center gap-4 mb-4">
            <img
              src={profileData?.profileImage}
              alt="Syed Bakhtawar Fahim"
              className="w-16 h-16 rounded-full object-cover"
            />
            <div>
              <h3 className="font-semibold">{profileData?.name}</h3>
              <p className="text-sm text-muted-foreground">
                {profileData?.title}
              </p>
            </div>
          </div>
          <p className="text-sm text-muted-foreground mb-4">
            {profileData?.description ||
              "5+ years of experience building scalable applications and data solutions."}
          </p>
          <Button size="sm" variant="outline" asChild className="w-full">
            <Link to="/about">View Profile</Link>
          </Button>
        </CardContent>
      </Card>
    </>
  );
};

export default ProfileInfo;
